import "./header.js";
import "./anchor-links.js";
import "./video.js";
import "./education-center-archive.js";
import "./education-center-video-lightbox.js";
import "./education-center-sticky-nav.js";
import "./blocks/interactive-device.js";

// import "./aos-animate.js";
